import { render, staticRenderFns } from "./couponShopPoolManage.vue?vue&type=template&id=31c0018c&scoped=true"
import script from "./couponShopPoolManage.vue?vue&type=script&lang=js"
export * from "./couponShopPoolManage.vue?vue&type=script&lang=js"
import style0 from "./couponShopPoolManage.vue?vue&type=style&index=0&id=31c0018c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c0018c",
  null
  
)

export default component.exports